import { TypedDocumentNode, gql } from '@apollo/client';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Card } from '@sorare/core/src/components/card/Card';

import { BuyCommonCard } from 'components/commonCard/BuyCommonCard';

import { AnyPlayerProperties } from './AnyPlayerProperties';
import { CommonPlayerPreview_composeTeamBenchObjectInterface } from './__generated__/index.graphql';

type Props = {
  commonPlayer: CommonPlayerPreview_composeTeamBenchObjectInterface & {
    __typename: 'ComposeTeamBenchCommonPlayer';
  };
  onStatsClick: () => void;
  showPlayerCostHighlight?: boolean;
};

export const CommonPlayerPreview = ({
  commonPlayer,
  onStatsClick,
  showPlayerCostHighlight,
}: Props) => {
  const { anyPlayer } = commonPlayer;
  return (
    <Vertical>
      <Card card={commonPlayer} onClick={onStatsClick} />
      <AnyPlayerProperties player={anyPlayer} onStatsClick={onStatsClick} />

      <BuyCommonCard
        commonPlayer={commonPlayer}
        showPlayerCostHighlight={showPlayerCostHighlight}
      />
    </Vertical>
  );
};

CommonPlayerPreview.fragments = {
  composeTeamBenchObjectInterface: gql`
    fragment CommonPlayerPreview_composeTeamBenchObjectInterface on ComposeTeamBenchObjectInterface {
      id
      anyPlayer {
        slug
        ...AnyPlayerProperties_anyPlayer
      }
      ...Card_composeTeamBenchObjectInterface
      ...BuyCommonCard_composeTeamBenchObjectInterface
    }
    ${AnyPlayerProperties.fragments.anyPlayer}
    ${Card.fragments.composeTeamBenchObjectInterface}
    ${BuyCommonCard.fragments.composeTeamBenchObjectInterface}
  ` as TypedDocumentNode<CommonPlayerPreview_composeTeamBenchObjectInterface>,
};
